import merge from 'deepmerge';
import { combineReducers } from 'redux';

const lenderContacts = () => (state = {
  lenderContacts: null,
}, action) => {
  if (action.type === 'FETCH_LENDER_CONTACTS_SUCCESS' && action.response.entities) {
    return merge.all([state, action.response.entities], {
      clone: false,
      arrayMerge: (destinationArray, sourceArray) => sourceArray,
    });
  }

  if (action.type === 'ADD_NEW_CONTACT_SUCCESS' && action.response) {
    const created = action.response?.data || action.response;
    const prevPayload = state.lenderContacts || {};
    const prevList = prevPayload.data || [];

    return {
      ...state,
      lenderContacts: {
        ...prevPayload,
        data: [created, ...prevList],
      },
      lastAddedContact: created,
    };
  }

  if (action.type === 'EDIT_CONTACT_SUCCESS' && action.response) {
    const updated = action.response?.data || action.response;
    const prevPayload = state.lenderContacts || {};
    const prevList = prevPayload.data || [];

    return {
      ...state,
      lenderContacts: {
        ...prevPayload,
        data: prevList.map((contact) => (contact.id === updated.id ? { ...contact, ...updated } : contact)),
      },
      lastEditedContact: updated,
    };
  }

  return state;
};

export default combineReducers({
  lenderContacts: lenderContacts(),
});
